"use client";

import { useEffect, useState } from "react";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

export default function InstallAppBanner() {
  const [installEvent, setInstallEvent] = useState<BeforeInstallPromptEvent | null>(null);
  const [isIos, setIsIos] = useState(false);
  const [show, setShow] = useState(false);
  const [iosExpanded, setIosExpanded] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !(window.navigator as any).standalone;
    if (ios) { setIsIos(true); setShow(true); return; }

    const handler = (e: Event) => {
      e.preventDefault();
      setInstallEvent(e as BeforeInstallPromptEvent);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!installEvent) return;
    await installEvent.prompt();
    const { outcome } = await installEvent.userChoice;
    if (outcome === "accepted") setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end gap-2">
      {/* Tooltip iOS — solo aparece al tocar el chip */}
      {isIos && iosExpanded && (
        <div className="bg-zinc-900 text-white text-xs rounded-xl px-3 py-2.5 shadow-xl border border-zinc-700 max-w-[200px] text-right leading-relaxed">
          Tocá <strong className="text-amber-400">Compartir</strong> →{" "}
          <strong className="text-amber-400">Añadir a inicio</strong>
        </div>
      )}

      {/* Chip compacto */}
      <button
        type="button"
        onClick={isIos ? () => setIosExpanded((v) => !v) : handleInstall}
        className="flex items-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white text-xs font-semibold px-3 py-2 rounded-full shadow-lg border border-zinc-700 transition-colors"
      >
        <span className="text-base leading-none">🍺</span>
        Instalar app
      </button>
    </div>
  );
}
